export default __webpack_public_path__ + "static/media/RPG_1.b75e2e9a.png";